import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Device } from 'src/app/models/device.model';
import { AtlasErrorCodes } from 'src/app/models/enums/atlas-error-codes.enum';
import { MessageBox } from 'src/app/models/message-box.model';

@Injectable({
  providedIn: 'root',
})
export class SharedService {
  private isNextClicked = new BehaviorSubject(false);
  currentNextClick = this.isNextClicked.asObservable();

  private deviceList = new BehaviorSubject([] as Device[]);
  currentDeviceList = this.deviceList.asObservable();

  private isNextDisabled = new BehaviorSubject(false);
  currentNextDisabled = this.isNextDisabled.asObservable();

  private isManualCardEntryButtonDisabled = new BehaviorSubject(false);
  currentManualCardEntryButtonDisabled = this.isManualCardEntryButtonDisabled.asObservable();

  private isContinueClicked = new BehaviorSubject(false);
  currentContinueClick = this.isContinueClicked.asObservable();

  private isErrorCreditCard = new BehaviorSubject(false);
  currentErrorCreditCard = this.isErrorCreditCard.asObservable();

  private isMobyDeviceError = new BehaviorSubject(false);
  currentMobyDeviceError = this.isMobyDeviceError.asObservable();

  private isManualCardEntryClicked = new BehaviorSubject(false);
  currentManualCardEntryClick = this.isManualCardEntryClicked.asObservable();

  private isSignatureObject1 = new BehaviorSubject(false);
  currentSignatureObject1 = this.isSignatureObject1.asObservable();

  private isSignatureObject2 = new BehaviorSubject(false);
  currentSignatureObject2 = this.isSignatureObject2.asObservable();

  private paymentMessage = new BehaviorSubject('');
  currentPaymentMessage = this.paymentMessage.asObservable();

  private isSuccessfulPayment = new BehaviorSubject(false);
  currentSuccessfulPayment = this.isSuccessfulPayment.asObservable();

  private paymentErrorMessage = new BehaviorSubject('');
  currentPaymentErrorMessage = this.paymentErrorMessage.asObservable();

  private isCashPayment = new BehaviorSubject(false);
  currentCashPayment = this.isCashPayment.asObservable();

  private isCashChecked = new BehaviorSubject(false);
  currentCashChecked = this.isCashChecked.asObservable();

  private isDoneClickedAndDisabled = new BehaviorSubject(false);
  currentDoneClickDisabled = this.isDoneClickedAndDisabled.asObservable();

  private isIpadConnected = new BehaviorSubject(false);
  currentConnectedIpad = this.isIpadConnected.asObservable();

  private clickContinueEvent = new BehaviorSubject(false);
  currentClickContinueEvent = this.clickContinueEvent.asObservable();

  private clickManualContinueEvent = new BehaviorSubject(false);
  currentClickManualContinueEvent = this.clickManualContinueEvent.asObservable();

  private modalType = new BehaviorSubject('');
  currentModalType = this.modalType.asObservable();

  private canceledByUser = new BehaviorSubject(false);
  currentCanceledByUser = this.canceledByUser.asObservable();

  private isSubmitBluefinClicked = new BehaviorSubject(false);
  currentSubmitBluefinClicked = this.isSubmitBluefinClicked.asObservable();

  private authCode = new BehaviorSubject<string | null>(null);
  currentAuthCode = this.authCode.asObservable();

  private clickContinueDeviceSelected = new BehaviorSubject(false);
  currentContinueDeviceClick = this.clickContinueDeviceSelected.asObservable();

  private selectedIpad = new BehaviorSubject<Device | null>(null);
  currentSelectedIpad = this.selectedIpad.asObservable();

  private isICargoResultWithError = new BehaviorSubject<boolean | null>(null);
  currentIsICargoResultWithError = this.isICargoResultWithError.asObservable();

  private bluefinError = new BehaviorSubject(false);
  currentBluefinError = this.bluefinError.asObservable();

  private isCustomTimeoutError = new BehaviorSubject(false);
  currentIsCustomTimeoutError = this.isCustomTimeoutError.asObservable();

  private isLoadingState = new BehaviorSubject(false);
  currentLoadingState = this.isLoadingState.asObservable();

  private isIpadClicked = new BehaviorSubject(false);
  currentIpadClicked = this.isIpadClicked.asObservable();

  private isExitICargoDisabled = new BehaviorSubject(false);
  currentExitICargoDisabled = this.isExitICargoDisabled.asObservable();

  private nextButtonName = new BehaviorSubject('Next');
  currentNextButtonName = this.nextButtonName.asObservable();

  private paymentType = new BehaviorSubject('Customer Payment');
  currentPaymentType = this.paymentType.asObservable();

  private transactionId = new BehaviorSubject<string>('');
  currentTransactionId = this.transactionId.asObservable();

  private isValidTransaction = new BehaviorSubject(true);
  currentValidTransaction = this.isValidTransaction.asObservable();

  private isHiddenCreditCard = new BehaviorSubject(false);
  currentIsHiddenCreditCard = this.isHiddenCreditCard.asObservable();

  private isNoSignatureCash = new BehaviorSubject(false);
  currentIsNoSignatureCash = this.isNoSignatureCash.asObservable();

  private isSomethingHappened = new BehaviorSubject(false);
  currentSomethingHappened = this.isSomethingHappened.asObservable();

  private message = new BehaviorSubject<MessageBox | undefined>(undefined);
  currentMessage = this.message.asObservable();

  private IsParameterValid = new BehaviorSubject(false);
  currentParameterValid = this.IsParameterValid.asObservable();

  private IsNoSignatureNoPayment = new BehaviorSubject(false);
  currentIsNoSignatureNoPayment = this.IsNoSignatureNoPayment.asObservable();

  private IsBluefinTokenRetry = new BehaviorSubject(false);
  currentIsBluefinTokenRetry = this.IsNoSignatureNoPayment.asObservable();

  private paymentSectionExpanded = new BehaviorSubject(true);
  currentPaymentSectionExpanded = this.paymentSectionExpanded.asObservable();

  private paymentSectionHidden = new BehaviorSubject(false);
  currentPaymentSectionHidden = this.paymentSectionHidden.asObservable();

  private contractSectionExpanded = new BehaviorSubject(false);
  currentContractSectionExpanded = this.contractSectionExpanded.asObservable();

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  constructor() {
    // This is intentional
  }

  updateNextClick(isClick: boolean) {
    this.isNextClicked.next(isClick);
  }

  updateDeviceList(deviceList: Device[]) {
    this.deviceList.next(deviceList);
  }

  updateContinueClick(isClick: boolean) {
    this.isContinueClicked.next(isClick);
  }

  updateNextDisabled(isDisabled: boolean) {
    this.isNextDisabled.next(isDisabled);
  }

  updateErrorCreditCard(isError: boolean) {
    this.isErrorCreditCard.next(isError);
  }

  updateMobyDeviceError(isError: boolean) {
    this.isMobyDeviceError.next(isError);
  }

  updateManualCardEntryClick(isClick: boolean) {
    this.isManualCardEntryClicked.next(isClick);
  }

  updateSignatureObject1(isValid: boolean) {
    this.isSignatureObject1.next(isValid);
  }

  updateSignatureObject2(isValid: boolean) {
    this.isSignatureObject2.next(isValid);
  }

  updatePaymentMessage(message: string) {
    this.paymentMessage.next(message);
  }

  updateSuccessfulPayment(isValid: boolean) {
    this.isSuccessfulPayment.next(isValid);
  }

  updateErrorPaymentMessage(message: string) {
    this.paymentErrorMessage.next(message);
  }

  updateCashPayment(isValid: boolean) {
    this.isCashPayment.next(isValid);
  }

  updateCashCheckbox(isValid: boolean) {
    this.isCashChecked.next(isValid);
  }

  updateDoneClickDisabled(isValid: boolean) {
    this.isDoneClickedAndDisabled.next(isValid);
  }

  updateConnectedIpad(isValid: boolean) {
    this.isIpadConnected.next(isValid);
  }

  updateClickContinueEvent(isValid: boolean) {
    this.clickContinueEvent.next(isValid);
  }

  updateClickManualContinueEvent(isClicked: boolean) {
    this.clickManualContinueEvent.next(isClicked);
  }

  updateModalType(message: string) {
    this.modalType.next(message);
  }

  updateCanceledByUser(isValid: boolean) {
    this.canceledByUser.next(isValid);
  }

  updateSubmitBluefinClick(isValid: boolean) {
    this.isSubmitBluefinClicked.next(isValid);
  }

  updateManualCardEntryButtonDisabled(isValid: boolean) {
    this.isManualCardEntryButtonDisabled.next(isValid);
  }

  updateAuthCode(message: string | null) {
    this.authCode.next(message);
  }

  updateContinueDeviceClick(isClick: boolean) {
    this.clickContinueDeviceSelected.next(isClick);
  }

  updateSelectedIpad(selectedIpad: Device | null) {
    this.selectedIpad.next(selectedIpad);
  }

  updateIsICargoResultWithError(isError: boolean) {
    this.isICargoResultWithError.next(isError);
  }

  updateBluefinError(isError: boolean) {
    this.bluefinError.next(isError);
  }

  updateIsCurrentTimeoutError(isError: boolean) {
    this.isCustomTimeoutError.next(isError);
  }

  updateLoadingState(isLoading: boolean) {
    this.isLoadingState.next(isLoading);
  }

  updateIpadClick(isClick: boolean) {
    this.isIpadClicked.next(isClick);
  }

  updateExitICargoDisabled(isDisabled: boolean) {
    this.isExitICargoDisabled.next(isDisabled);
  }

  updateNextButtonName(message: string) {
    this.nextButtonName.next(message);
  }

  updatePaymentType(message: string) {
    this.paymentType.next(message);
  }

  updateTransactionId(transactionId: string) {
    this.transactionId.next(transactionId);
  }

  updateValidTransaction(isValid: boolean) {
    this.isValidTransaction.next(isValid);
  }

  updateIsHiddenCreditCard(isHidden: boolean) {
    this.isHiddenCreditCard.next(isHidden);
  }

  updateIsNoSignatureCash(isValid: boolean) {
    this.isNoSignatureCash.next(isValid);
  }

  updateSomethingHappened(isValid: boolean) {
    this.isSomethingHappened.next(isValid);
  }

  showMessage(message: MessageBox | undefined) {
    this.message.next(message);
  }

  hideMessage() {
    this.message.next(undefined);
  }

  updateParameterValid(isValid: boolean) {
    this.IsParameterValid.next(isValid);
  }

  updateIsNoSignatureNoPayment(isNoSignatureNoPayment: boolean) {
    this.IsNoSignatureNoPayment.next(isNoSignatureNoPayment);
  }

  updateIsBluefinTokenRetry(isBluefinTokenRetry: boolean) {
    this.IsBluefinTokenRetry.next(isBluefinTokenRetry);
  }

  updatePaymentSectionExpanded(isExpanded: boolean) {
    this.paymentSectionExpanded.next(isExpanded);
  }

  updatePaymentSectionHidden(isHidden: boolean) {
    this.paymentSectionHidden.next(isHidden);
  }

  updateContractSectionExpanded(isExpanded: boolean) {
    this.contractSectionExpanded.next(isExpanded);
  }

  public uuid(): string {
    const uuidValue = crypto.randomUUID();
    return uuidValue;
  }

  //Decline scenarios: Return true if the error code exists in the Enum, otherwise false.
  public existErrorCode(errorCode: string): boolean {
    const exist = Object.values(AtlasErrorCodes)[Object.keys(AtlasErrorCodes).indexOf(errorCode)];
    if (exist != undefined) return true;
    else return false;
  }
}
